import React, { useState } from "react";
import HeroSection from "../components/heroSection";
import InfoSection from "../components/infoSection";
import { Navbar } from "./../components/navbar";
import { Sidebar } from "./../components/sidebar";
import ContactModal from "../components/contactModal";

import Image1 from "../images/design-notes.svg";
import Image2 from "../images/space.svg";
import InfoSectionLight from "../components/infoSectionLight";
import Services from "../components/services";
import Footer from "../components/footer";

export const Home = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const toggleContact = () => {
    setIsContactOpen(!isContactOpen);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} toggleContact={toggleContact} />
      <ContactModal isOpen={isContactOpen} toggle={toggleContact} />
      <Navbar toggle={toggle} toggleContact={toggleContact} />
      <HeroSection />
      <InfoSection
        image={Image1}
        id="about"
        subtitle="Who We Are"
        title="Your Trusted Development Partner"
        text="ESAN DEV is a full-service web and application development company dedicated to helping businesses thrive in the digital age. With years of experience and a passionate team of developers, designers, and strategists, we transform ideas into powerful digital solutions that drive results."
        btnText="Learn More"
      />
      <InfoSectionLight
        image={Image2}
        id="discover"
        subtitle="Our Approach"
        title="Innovation Meets Excellence"
        text="We believe in creating digital experiences that not only look stunning but also perform exceptionally. From responsive websites to feature-rich mobile applications, we use cutting-edge technologies and agile methodologies to deliver projects on time and within budget. Your success is our priority."
        btnText="View Portfolio"
        onBtnClick={toggleContact}
      />
      <Services />
      <InfoSectionLight
        image={Image1}
        id="process"
        subtitle="How We Work"
        title="From Concept to Launch"
        text="Our development process is transparent and collaborative. We start with understanding your goals, then move through planning, design, development, and rigorous testing. We keep you involved at every stage, ensuring the final product exceeds your expectations and serves your users perfectly."
        btnText="Start a Project"
        onBtnClick={toggleContact}
      />
      <Footer />
    </>
  );
};
